export { useMediaQuery } from '@material-ui/core'

export const mobileMiniScreen = '(max-width:365px)' // For screen Galaxy fold (front screen), Iphone SE 2, Samsung S8
export const mobileSmallScreen = '(max-width: 375px)'
export const mobileScreen = '(max-width:480px)'
export const landscapeMobileScreen = '(max-width:767px)'
export const tabletScreen = '(max-width:991px)'
export const desktopScreen = '(min-width:991px)'
